module.exports = __webpack_public_path__ + "static/media/WizardsScreenshot05.e0f47d42.png";